import React from 'react';

import { useFormatNumber } from '~/i18n/hooks/useFormatNumber/useFormatNumber';

import { Nullable } from '../../../types/Nullable';
import { StatusType } from '../../../types/StatusType';
import { Chip } from '../Chip';

interface Props {
  count: Nullable<number>;
  countStatus?: StatusType;
}

export const CountChip = ({ count, countStatus }: Props) => {
  const formatNumber = useFormatNumber();
  return <Chip mode="tag" text={formatNumber(count)} status={countStatus} />;
};
